<template>
  <div class="inbox-dropdown__timer">
    <span class="display">{{ timer }}</span>
  </div>
</template>

<script>

export default {
  props: {
    timestamp: {
        type: String,
        required: true
    },
    currentTimestamp: {
        type: String,
        required: true
    }
  },
  data() {
    return {
      time: 0
    }
  },
  mounted() {
    setInterval(() => this.time += 1, 1000)
  },
  computed: {
    timer() {
      const timestamp = new Date(this.timestamp);
      const currentTimestamp = new Date(this.currentTimestamp);
      currentTimestamp.setSeconds(currentTimestamp.getSeconds() + this.time);

      const timeDifferenceInSeconds = Math.max(0, Math.floor((currentTimestamp - timestamp) / 1000));

      const days = Math.floor(timeDifferenceInSeconds / 86400);
      const hours = Math.floor((timeDifferenceInSeconds % 86400) / 3600);
      const minutes = Math.floor((timeDifferenceInSeconds % 3600) / 60);
      const seconds = timeDifferenceInSeconds % 60;

      const formattedDays = days > 0 ? `${days}d ` : '';
      const formattedHours = hours.toString().padStart(2, '0');
      const formattedMinutes = minutes.toString().padStart(2, '0');
      const formattedSeconds = seconds.toString().padStart(2, '0');

      return `${formattedDays}${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    }
  }
}
</script>

<style lang="scss">
.inbox-dropdown {
  &__timer {
    position: absolute;
    top: 0;
    font-size: 0.8em;
    width: 100%;
    text-align: center;

    .display {
      color: #fff;
      width: 100%;
      padding: .3rem .3rem;
      display: inline-block;
      border-radius: 7%;
      background: rgba(var(--vs-primary), 1);
    }
  }
}
</style>